<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
    extends: HorizontalBar,
    props:['dataNTR'],
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{
                    label: 'Active',
                    data: [],
                    backgroundColor: []
                }]
            },
            options: {
                tooltips:{
                  enabled: true
                },
                legend: {
                    display: false,
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            fontSize: 14,
                            fontStyle: "bold"
                        }
                    }],
                    yAxes: [{
                        display: true,
                        ticks: {
                            suggestedMin: 0,
                            precision: 10,
                            fontSize: 14,
                            fontStyle: "bold"
                        }
                    }],
                    x: {
                        min: 0,  // Set the minimum value for the x-axis (which is the y-axis in a horizontal chart)
                        max: 0,   // Set the maximum value for the x-axis
                        beginAtZero: false  // Optional: Decide if you want the chart to start at zero
                    }
                }
            }
        }
    },
    methods:{
        getChart(){
            let dataNTR = this.dataNTR;
            this.chartData.labels = dataNTR["list"].map(label => label.split('-'));
            this.chartData.datasets[0].data= dataNTR["data"];
            this.chartData.datasets[0].backgroundColor = dataNTR["data"].map(value => value.x < 0 ? 'red' : '#AFEF97');
            this.options.scales.xAxes[0].scaleLabel.labelString = dataNTR.name;
            this.options.scales.xAxes[0].max = dataNTR.max;
            this.options.scales.xAxes[0].min = dataNTR.min;
            this.renderChart(this.chartData, this.options)
        }
    },
    watch:{
        dataNTR(){
            this.getChart()
        }
    }
}
</script>
